
<section class="topbar-container" *ngIf="!(isMobileScreen$ | async)">
    <div class="grid w-full m-0">
        <div class="col-4 md:col-4 lg:col-4 flex align-items-center px-3 gap-3">
            <div class="logo">
                <img src="/assets/images/topbar-logo.svg" width="89.47px" height="32px" alt="">
            </div>
            <div
                class="current-store-badge"
                [class.current-store-badge--switchable]="hasMultipleStores"
                *ngIf="displayStoreName"
                (click)="openStorePicker()"
                [attr.role]="hasMultipleStores ? 'button' : null"
                [attr.aria-label]="hasMultipleStores ? ('switch-store' | translate) : null"
                [pTooltip]="hasMultipleStores ? ('switch-store' | translate) : null"
                tooltipPosition="bottom"
            >
                <i class="pi pi-shop"></i>
                <span class="current-store-badge__name">{{ displayStoreName }}</span>
                <i class="pi pi-chevron-down current-store-badge__caret" *ngIf="hasMultipleStores"></i>
            </div>
        </div>
        <div class="col-4 md:col-4 lg:col-4">
            <div class="flex justify-content-center">
                <p-iconfield>
                    <p-inputicon styleClass="pi pi-search" />
                    <input type="text" pInputText [placeholder]="'search' | translate" />
                </p-iconfield>
            </div>
        </div>
        <div class="col-4 md:col-3 lg:col-4 px-3">
            <div class="flex flex-row justify-content-end align-items-center gap-4">
                <div class="notification-section">
                    <app-notification-dropdown></app-notification-dropdown>
                </div>
                <div class="profile-image" (click)="profileMenu.toggle($event)" style="cursor: pointer;">
                    <img src="/assets/images/avatar.svg" alt="">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="topbar-container mobile-styles" *ngIf="(isMobileScreen$ | async)">
    <div class="grid w-full m-0">
        <div class="col-12">
            <div class="grid w-full m-0">
                <div class="col-6 flex align-items-center px-3 gap-2">
                    <div class="logo">
                        <img src="/assets/images/topbar-logo.svg" alt="">
                    </div>
                    <div
                        class="current-store-badge current-store-badge--compact"
                        [class.current-store-badge--switchable]="hasMultipleStores"
                        *ngIf="displayStoreName"
                        (click)="openStorePicker()"
                        [attr.role]="hasMultipleStores ? 'button' : null"
                        [attr.aria-label]="hasMultipleStores ? ('switch-store' | translate) : null"
                    >
                        <i class="pi pi-shop"></i>
                        <span class="current-store-badge__name">{{ displayStoreName }}</span>
                        <i class="pi pi-chevron-down current-store-badge__caret" *ngIf="hasMultipleStores"></i>
                    </div>
                </div>
                <div class="col-6 px-3">
                    <div class="flex flex-row justify-content-end align-items-center gap-4">
                        <div class="notification-section">
                            <app-notification-dropdown></app-notification-dropdown>
                        </div>
                        <div class="profile-image" (click)="profileMenu.toggle($event)" style="cursor: pointer;">
                            <img src="/assets/images/avatar.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid w-full m-0">
                <div class="col-9">
                    <div class="flex justify-content-center">
                        <p-iconfield>
                            <p-inputicon styleClass="pi pi-search" />
                            <input type="text" pInputText [placeholder]="'search' | translate" />
                        </p-iconfield>
                    </div>
                </div>
                <div class="col-3 flex justify-content-end align-items-center">
                    <div class="flex justify-content-end">
                        <div class="flex align-items-center" (click)="onToggleSidebar()">
                            <i class="pi pi-bars"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<p-popover #profileMenu [style]="{ minWidth: '200px' }" styleClass="profile-menu-overlay">
    <div class="profile-menu">
        <button type="button" class="profile-menu__item" (click)="navigateToSettings(profileMenu)">
            <i class="pi pi-cog"></i>
            <span>{{ 'settings' | translate }}</span>
        </button>
    </div>
</p-popover>

<app-store-picker-dialog
    [(visible)]="showStorePicker"
    [stores]="ownerStores"
    [loading]="storesLoading"
    [closable]="!storeSwitchInFlight"
    [currentStoreId]="currentStoreId"
    (storeSelected)="onStoreSwitched($event)">
</app-store-picker-dialog>
